import * as THREE from 'three/webgpu';
import type { DetailMaterial, TerrainDetail } from '../../engine/terrain/TerrainDetail';

let shared: TerrainDetail | null = null;

/**
 * The ground's detail textures close by (Poly Haven, CC0; see CREDITS.md), loaded once and shared
 * by every world. Their means were measured from the colour maps (linear RGB), so the detail
 * varies around the palette's colour instead of tinting it.
 */
export function terrainDetail(): TerrainDetail {
  if (shared) return shared;
  const loader = new THREE.TextureLoader();
  const load = (path: string, srgb: boolean) => {
    const t = loader.load(path);
    t.wrapS = THREE.RepeatWrapping;
    t.wrapT = THREE.RepeatWrapping;
    t.colorSpace = srgb ? THREE.SRGBColorSpace : THREE.NoColorSpace;
    t.anisotropy = 8;
    return t;
  };
  const set = (
    id: string,
    size: number,
    mean: [number, number, number],
    strength: number,
    bump: number,
  ): DetailMaterial => ({
    albedo: load(`assets/polyhaven/${id}/${id}_diff_1k.jpg`, true),
    normal: load(`assets/polyhaven/${id}/${id}_nor_gl_1k.jpg`, false),
    size,
    mean,
    strength,
    bump,
  });
  shared = {
    ground: set('aerial_grass_rock', 4, [0.1695, 0.1215, 0.0251], 0.6, 1),
    rock: set('rock_face', 4, [0.121, 0.0612, 0.0317], 0.8, 1.2),
    sand: set('coast_sand_01', 2, [0.2243, 0.1712, 0.1073], 0.6, 0.8),
    // Softer: its dark marks would repeat, and its relief caught the sky as glitter.
    snow: set('snow_02', 4, [0.3791, 0.3787, 0.3888], 0.35, 0.2),
  };
  return shared;
}
